module.exports = __webpack_public_path__ + "static/media/ruler-triangle.27459b6a.svg";